import React from "react";
import PageLayout from "../../components/Clearith/PageLayout";
import FormationsContent from "../../components/Clearith/FormationsContent";

const ServicePage: React.FC = () => {
  return (
    <PageLayout title="Nos formations" breadcrumb="Formations">
      <FormationsContent />
    </PageLayout>
  );
};

export default ServicePage;
